export interface DeviceMetadata {
  deviceBrand: string;
  deviceCategory?: string;
  deviceManufacturer: string;
  deviceModel: string;
  operatingSystemName: string;
}

interface VersionInfo {
  major?: number;
  minor?: number;
  patch?: number;
  readable?: string;
}

export interface Version {
  api?: VersionInfo;
  debug?: string;
  firmware?: VersionInfo;
  os?: VersionInfo;
  sdk?: VersionInfo;
}

export enum DeviceTypes {
  SMARTTV = 'smarttv',
  STB = 'ipstb',
  WEB = 'web',
}
